import { staffMemberFragment } from "@saleor/fragments/staff";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { PermissionSiteDetails } from "./types/PermissionSiteDetails";




export const permissionSiteDetailsQuery = gql`
  ${staffMemberFragment}
  query PermissionSiteDetails {
    permissionSite {
        name
        users {
          ...StaffMemberFragment
          avatar(size: 48) {
            url
          }
        }
    }

  }
`;
export const usePermissionSiteDetailsQuery = makeQuery<
   PermissionSiteDetails,null
>(permissionSiteDetailsQuery);
